import { render, staticRenderFns } from "./MetricsComponent.vue?vue&type=template&id=2278d7ae"
import script from "./MetricsComponent.vue?vue&type=script&lang=js"
export * from "./MetricsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports